import axios from "axios";

export default {
    getEmptyItem(contractType, firstVatRateId) {
        switch (contractType) {
            case 'adding':
            case 'adding_buy':
            case 'adding_sell':
                return this.getAddingEmptyItem(firstVatRateId);
            case 'invoicing_pl_margin':
                return this.getMarginEmptyItem(firstVatRateId);
            default:
                return this.getDefaultEmptyItem(firstVatRateId);
        }
    },
    getMarginEmptyItem(firstVatRateId) {
        return {
            name: '',
            quantity: 1.00,
            unit: '',
            price: 0,
            net_amount: 0,
            gross_amount: 0,
            margin: 0,
            margin_vat_rate: firstVatRateId,
            margin_vat_amount: 0,
            symbol: '',
            standard_item_id: 0,
            pkwiu: '',
            description: '',
            has_discount: false,
            price_before_discount: 0,
            discount: 0,
            procedure:0,
            gtu:0,
            excise_tax_amount: 0,
        };
    },
    getDefaultEmptyItem(firstVatRateId) {
        return {
            name: '',
            quantity: 1.00,
            unit: '',
            price: 0,
            net_amount: 0,
            vat_rate: firstVatRateId,
            vat_amount: 0,
            gross_amount: 0,
            symbol: '',
            pkwiu: '',
            standard_item_id: 0,
            description: '',
            has_discount: false,
            price_before_discount: 0,
            discount: 0,
            procedure:0,
            gtu:0,
            excise_tax_amount: 0,
        };
    },
    getAddingEmptyItem(firstVatRateId) {
        return {
            name: '',
            quantity: 1.00,
            unit: '',
            price: 0,
            net_amount: 0,
            standard_item_id: 0,
            vat_rate: firstVatRateId,
            vat_amount: 0,
            gross_amount: 0,
            procedure:0,
            gtu:0,
        };
    },
    getEmptyOtherEntity(){
        return {
            document_other_entity_type_id : 0,
            role_name:'',
            participation :0,
            contractor_id : 0,
            contractor_id_number_selected:0,
        }
    },

    fetchContractData(contractId) {
        return axios.get(`/records/contracts/contract-data/${contractId}`);
    },
};
